<template>
	<div style="margin: 10px;">
		<el-row>
			<el-col :span="24">
				<el-card class="box-card">
					<el-row>
						<el-col :span="24">
							<button class="selectAll" @click="add(0)" style="margin: 0 0 30px 0;">添加一级栏目</button>
							<el-table   :default-sort = "{prop: 'id',prop:'order', order: 'descending'}" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
							 element-loading-background="rgba(0, 0, 0, 0.8)" size="mini" ref="multipleTable" :data="tableData" style="width: 100%"
							 border :header-cell-style="{background:'#E5E7EE',color:'#000000'}" row-key="id"  :tree-props="{children: 'childRpColum', hasChildren: 'hasChildren'}"
							 @select-all="selectAll"   >
								<!-- 	<el-table-column type="selection" width="55" align="center">
								</el-table-column> -->
								<el-table-column prop="id" label="编号" align="center "  sortable>
								</el-table-column>
								<el-table-column prop="order" label="排序" align="center" sortable>
								</el-table-column>
								<el-table-column prop="columname" label="栏目名称" align="center">
								</el-table-column>
								<el-table-column prop="display" label="导航栏显示" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.display == 1?'都显示':scope.row.display == 2 ?'头部显示':scope.row.display == 3 ?'底部显示':scope.row.display == 0?'都不显示':''}}</span>
									</template>
								</el-table-column>
								<el-table-column prop="modular" label="所属模块" align="center">
									<template slot-scope="scope">
										<span>{{scope.row.modular == 1?'简介':scope.row.modular == 2 ?'文章':scope.row.modular == 3 ?'产品':scope.row.modular == 4?'下载':scope.row.modular == 5?'图片':scope.row.modular == 6?'留言':scope.row.modular == 7?'表单':scope.row.modular == 8 ? '专题':''}}</span>
									</template>
								</el-table-column>
								<el-table-column fixed="right" label="更多操作">
									<template slot-scope="scope">
										<el-button type="success" icon="el-icon-plus" circle  size="small" class="addColumn"   @click="add(1,scope.row.modular,scope.row.id)"></el-button>
										<el-button type="success" icon="el-icon-edit" circle  size="small"  @click.native.prevent="update('update',scope.row)"></el-button>
											<el-button type="danger" icon="el-icon-delete" circle  @click.native.prevent="deleteRow(scope.$index,scope.row)"  size="small"></el-button>
										
										<!-- <el-button type="text" size="small" @click="add(1,scope.row.modular,scope.row.id)">
											增加子栏目
										</el-button>
										<span>|</span>
										<el-button @click="update('update',scope.$index, scope.row)" type="text" size="small">
											编辑
										</el-button>
										<span>|</span>
										<el-button @click="deleteRow(scope.$index, scope.row)" type="text" size="small">
											删除
										</el-button> -->
									</template>
								</el-table-column>
							</el-table>
							<!-- <div class="tableFooter"> -->
								<!-- <button class="selectAll" @click="toggleSelection(tableData)">全选</button> -->
								<!-- <button class="del">批量删除</button> -->
							<!-- </div> -->
							<!-- 	<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
							 :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total">
							</el-pagination> -->
						</el-col>
					</el-row>

				</el-card>
			</el-col>
		</el-row>
		<el-dialog :title="title" :visible.sync="dialogVisible" width="35%" :before-close="handleClose" >
			<el-form label-position="left" label-width="90px" :model="formDialog" size="mini" :rules="rules" ref="formDialog">
				<el-form-item label="栏目名称" prop="name">
					<el-input v-model="formDialog.name" size="mini"></el-input>
				</el-form-item>
				<el-form-item label="是否显示">
					<el-select v-model="formDialog.is_show" placeholder="请选择是否显示" size="mini">
						<el-option label="都显示" value="1">都显示</el-option>
						<el-option label="头部显示" value="2">头部显示</el-option>
						<el-option label="底部显示" value="3">底部显示</el-option>
						<el-option label="不显示" value="0">不显示</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="模块类型">
					<span style="color: #000;font-size: 16px;" v-show="Setypes">{{types}}</span>
					<el-select v-model="formDialog.se_type" placeholder="请选择模块类型" size="mini" v-show="selectType">
						<el-option label="简介" value="1"></el-option>
						<el-option label="文章" value="2"></el-option>
						<el-option label="产品" value="3"></el-option>
						<el-option label="下载" value="4"></el-option>
						<el-option label="图片" value="5"></el-option>
						<el-option label="留言" value="6"></el-option>
						<el-option label="表单" value="7"></el-option>
						<el-option label="专题" value="8"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否首页显示">
					<el-select v-model="formDialog.index" placeholder="请选择是否显示" size="mini">
						<el-option label="显示" value="1">显示</el-option>
						<el-option label="不显示" value="0">不显示</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button class="selectAll" @click="Onsubmit('formDialog')">提交</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import request from '../../../assets/js/request.js'
	import qs from 'qs'
	export default {
		data() {
			return {
				form: {
					one: '',
					two: '',
					three: '',
				},
				formDialog: {
					name: '',
					is_show: '',
					types: '',
					se_type: '',
					index:'',
				},
				rules:{
					name:[
						{required:true,message:'请输入栏目名称',tigger:'blur'}
					]
				},
				Setypes: false,
				selectType: false,
				title: '添加子栏目',
				tableData: [],
				currentPage: 1,
				pageSize: 5,
				total: 0,
				isAllSelect: false,
				dialogVisible: false,
				types: '',
				addType: '',
				columnId: '',
				typesId: '',
				loading: false
			}
		},
		created() {
			this.getData()
		},
		methods: {
			//获取列表数据
			getData() {
				this.loading = true
				var obj = this;
				obj.$http({
					method: 'get',
					url: 'api/v1/column/list',
					params: {
						// currentPage: currentPage,
						// pageSize: pageSize,
						 
					},
				}).then((res) => {
					if (res.data.status == 200) {
						this.loading = false
						this.tableData = res.data.data
						this.total = res.data.data.total
					} else {
						obj.$message.error(res.data.message)
					}
				})
			},
			//添加一级栏目
			add(type, modular, id) {
				this.addType = type
				if (type == 0) {
					this.dialogVisible = true, this.selectType = true, this.Setypes = false
					this.title = '增加栏目'
				} else {
					this.title = '增加子栏目'
					this.columnId = id
					this.dialogVisible = true, this.Setypes = true, this.selectType = false,
						this.types = modular == 1 ? '简介' : modular == 2 ? '文章' : modular == 3 ? '产品' : modular == 4 ? '下载' : modular == 5 ?
						'图片' : modular == 6 ? '留言' : modular == 7 ? '表单' : modular == 8 ? '专题':''
					this.typesId = modular
				}
			},
			Onsubmit(formName) {
				console.log(this.formDialog)
				 this.$refs[formName].validate((valid) => {
				          if (valid) {
				           var obj = this;
				           obj.$http({
				           	method: 'post',
				           	url: 'api/v1/column/add',
				           	data: {
				           		type: this.addType,
				           		id: this.columnId,
				           		columname: this.formDialog.name,
				           		display: this.formDialog.is_show,
				           		modular: this.formDialog.se_type == undefined || this.formDialog.se_type == '' ? this.typesId : this.formDialog.se_type,
								index:this.formDialog.index,   
				           	},
				           }).then((res) => {
				           	if (res.status == 200) {
				           		this.dialogVisible = false
				           		this.getData()
				           		this.addType = ''
				           		this.formDialog.name = ''
				           		this.formDialog.is_show = ''
				           		this.formDialog.se_type = ''
								this.formDialog.index = ''
				           	} else {
				           		obj.$message.error(res.message)
				           	}
				           })
				          } else {
				            console.log('error submit!!');
				            return false;
				          }
				        });
				
			},
			//修改/添加
			update(iden, rows) {
				this.$router.push({
					path: '/home/columnAdd',
					query: {
						rows: rows,
						iden: iden
					}
				})
			},
			deleteRow(index, rows) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					var obj = this;
					obj.$http({
						method: 'get',
						url: 'api/v1/column/delete',
						params: {
							columnId: rows.id,
							uid:localStorage.getItem('uid')
						},
					}).then((res) => {
						if (res.data.status == 500) {
							obj.$message.error('请先删除子栏目')
							return;
						}
						if (res.status == 200) {
							obj.$message.success('删除成功')
							this.getData()
						} else {
							obj.$message.error(res.data.message)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			//分页事件
			handleSizeChange(val) {
				this.pageSize = val; //将每页显示的条数 = 改变的值
				this.getData(this.currentPage, this.pageSize)
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getData(this.currentPage, this.pageSize)
			},
			// 全选/取消选操作
			selectAll(selection, first) {
				if (!first) {
					this.isAllSelect = !this.isAllSelect;
				}
				selection.map(el => {
					if (el.children) {
						el.children.map(j => {
							this.toggleSelection(j, this.isAllSelect);
						});
						if (el.children.length > 0) {
							this.selectAll(el.children, true);
						}
					}
				});
			},
			//全选
			toggleSelection(row, select) {
				if (select) {
					this.$refs.multipleTable.toggleRowSelection(row, select);
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			//批量删除
			del() {
				if (this.$refs.multipleTable.selection.length == 0) {
					this.$message.error('请选择要删除的表格信息！');
					return;
				}
				// var obj = this;
				// obj.$http({
				// 	method: 'get',
				// 	url: 'api/v1/column/list',
				// 	data: qs.stringify({
				// 			title:this.form.title,
				// 	desc:this.form.desc,
				// 	pic:this.form.pic,
				// 	}),
				// }).then((res) => {
				// 	if (res.data.code == 1) {
				// 		this.tableData = res.data.data
				// 		this.total = res.data.data.total
				// 	} else {
				// 		obj.$message.error(res.data.msg)
				// 	}
				// })
			},
			handleClose(done) {
				done();
			}
		},
	}
</script>

<style scoped="scoped">
	.selectAll{
		float: none;
	}
	/deep/ .el-input__inner {
		height: 40px !important;
	}

	/deep/ .el-form-item__label {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #000000;
		line-height: 24px;
	}

	/deep/ .el-button--text {
		font-family: PingFang SC;
		font-weight: 400;
		color: #7C96F8;
		line-height: 24px;
	}

	span ,/deep/ .el-table .cell{
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		line-height: 24px;
	}

	.chenggong {
		width: 49px;
		height: 16px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 24px;
		opacity: 0.7;
	}

	.fail {
		width: 33px;
		height: 16px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #76B67E;
		line-height: 24px;
	}

	/deep/ .el-message {
		z-index: 9999999999999;
	}
	/deep/ .el-table__row--level-0,/deep/ .expanded{
		/* background-color: #fdf5e6; */
	}
	/deep/ .el-table__row--level-1{
		background-color:#f0f9eb;
	}
/deep/ .el-table__row--level-2{
		background-color:#fdf5e6;
	}
	.addColumn{
	background-color: #7C96F8;
	color: #FFFFFF;
	border: 1px solid #7C96F8;
	}
</style>



// WEBPACK FOOTER //
// src/views/system/column/column.vue